import { useMemo } from 'react'

import { getUserOrganisationIds, useUserContext } from '@acre/utils'

import usePermissionResolution from '@broker-crm-common/Permission/usePermissionResolution'

const COMPLIANCE_VIEW_PATH = '/cases/compliance-view'
const BOARD_VIEW_PATH = '/cases/board-view'

/**
 * The cases list a settled user belongs on: compliance reviewers land on the compliance
 * view, everyone else on the board.
 */
const useCasesLandingPath = ({ skip }: { skip?: boolean } = {}) => {
  const user = useUserContext()

  const organisation = useMemo(() => (user ? getUserOrganisationIds({ user }).all : []), [user])

  const inputs = useMemo(
    () => [
      { gates: ['VIEW_CASE_COMPLIANCE'] as PermissionGateName[], entityIdsCollection: { organisation } },
      { gates: ['EDIT_CASE'] as PermissionGateName[], entityIdsCollection: { organisation } },
    ],
    [organisation],
  )

  const { isInitialCallComplete, gates } = usePermissionResolution({ inputs, skip: !!skip || !user })

  const isComplianceUser = gates.includes('VIEW_CASE_COMPLIANCE') && !gates.includes('EDIT_CASE')

  return {
    isInitialCallComplete,
    isComplianceUser,
    path: isComplianceUser ? COMPLIANCE_VIEW_PATH : BOARD_VIEW_PATH,
  }
}

export default useCasesLandingPath
